import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const Nav = () => {
  return (
    <header>
      <nav className="navigation">
        <div className="nav-mobile-container">
          <div className="nav-logo-container">
            <Link to="/" title="Lit Fibre" aria-label="Lit Fibre">
              <div className={'nav-logo'}>
                <StaticImage src="../images/logo-white.avif" alt="Lit Logo" />
              </div>
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Nav;
